<template>
  <div class="app-container">
    <div class="header">
      <el-select
        v-model="select"
        slot="prepend"
        :placeholder="this.$t('sensorsmanage.sensorbaseinfo.select.hint')"
        style="width: 160px"
        @change="selectChange()"
      >
        <el-option
          :label="this.$t('sensorsmanage.sensorbaseinfo.select.mac')"
          value="1"
        ></el-option>
        <el-option
          :label="this.$t('sensorsmanage.sensorbaseinfo.select.phone')"
          value="2"
        ></el-option>
        <el-option
          :label="this.$t('sensorsmanage.sensorbaseinfo.select.sensor')"
          value="3"
        ></el-option>
      </el-select>
      <el-input
        :placeholder="this.$t('sensorsmanage.sensorbaseinfo.hint')"
        v-model="search"
        class="input-with-select"
        style="width: 60%"
      >
        <el-button
          type="info"
          slot="append"
          @click="sensorSearchBaseInfo()"
          icon="el-icon-search"
        ></el-button>
      </el-input>

      <el-button
        type="success"
        size="mini"
        @click="openInsertSensorBaseInfo()"
        class="btnInsert"
        icon="el-icon-search"
        >{{ $t("sensorsmanage.sensorbaseinfo.insert.btn") }}
      </el-button>
    </div>
    <el-table :data="sensorBaseInfos" style="width: 100%">
      <el-table-column
        fixed
        :label="this.$t('sensorsmanage.sensordata.historydata.title')"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.tireTemperature }}
<!--          历史数据按钮-->
          <el-button @click="drawerOpen(scope.row.macId)" type="primary">
            {{ $t("sensorsmanage.sensordata.historydata.title") }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        :label="this.$t('sensorsmanage.sensorbaseinfo.mac')"
        prop="macId"
        width="150"
      >
      </el-table-column>
      <el-table-column
        fixed
        :label="this.$t('sensorsmanage.sensorbaseinfo.sensorid')"
        prop="sensorId"
        width="150"
      >
      </el-table-column>
      <el-table-column
        :label="this.$t('sensorsmanage.sensorbaseinfo.phone')"
        prop="phone"
        width="150"
      >
      </el-table-column>
      <el-table-column
        width="150"
        prop="bleconnectionSensor"
        :label="this.$t('sensorsmanage.sensorbaseinfo.bleconnectionSensor')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="companyID"
        :label="this.$t('sensorsmanage.sensorbaseinfo.companyID')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="ignstatus"
        :label="this.$t('sensorsmanage.sensorbaseinfo.ignstatus')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="mileageOFTirePressureSensor"
        :label="this.$t('sensorsmanage.sensorbaseinfo.mileageOFTirePressureSensor')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="presentDateAndTime"
        :label="this.$t('sensorsmanage.sensorbaseinfo.presentDateAndTime')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="projectCode"
        :label="this.$t('sensorsmanage.sensorbaseinfo.projectCode')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="softwareVersion"
        :label="this.$t('sensorsmanage.sensorbaseinfo.softwareVersion')"
      ></el-table-column>
      <el-table-column
        width="150"
        prop="vehicleOdometer"
        :label="this.$t('sensorsmanage.sensorbaseinfo.vehicleOdometer')"
      ></el-table-column>

      <el-table-column
        :label="this.$t('sensorsmanage.sensorbaseinfo.operate')"
        prop=""
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tag
            type="warning"
            class="btn"
            @click="openUpdateSensorBaseInfo(scope.row)"
            >{{ $t("sensorsmanage.sensorbaseinfo.modify.btn") }}</el-tag
          >
          <el-tag
            type="danger"
            class="btn"
            @click="deleteOneSensorBaseInfo(scope.row.macId)"
            >{{ $t("sensorsmanage.sensorbaseinfo.delete") }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 传感器历史数据  :before-close="handleClose"-->
    <el-drawer
      size="80%"
      :title="drawerTitle"
      :visible.sync="drawer"
      :direction="direction"
      style="font-size: 22px"
    >
      <div class="header_drawer" :visible.sync="drawer">
        <el-select
          v-model="drawerSelect"
          slot="prepend"
          :placeholder="this.$t('sensorsmanage.sensordata.historydata.select.hint1')"
          style="width: 180px"
          @change="drawerSelectChange()"
        >
          <el-option
            :label="this.$t('sensorsmanage.sensordata.historydata.select.1')"
            value="1"
          ></el-option>
          <el-option
            :label="this.$t('sensorsmanage.sensordata.historydata.select.2')"
            value="2"
          ></el-option>
          <el-option
            :label="this.$t('sensorsmanage.sensordata.historydata.select.3')"
            value="3"
          ></el-option>
          <el-option
            :label="this.$t('sensorsmanage.sensordata.historydata.select.4')"
            value="4"
          ></el-option>
        </el-select>
        <el-input
          :placeholder="this.$t('sensorsmanage.sensordata.historydata.select.hint2')"
          v-model="drawerSearch"
          class="input-with-select"
          style="width: 60%"
          v-if="drawerSelect != 1 && drawerSelect != 2"
        >
        </el-input>

        <el-slider
          v-model="tirePressureValue"
          range
          :marks="marks"
          style="width: 50%; margin-left: 20px"
          v-if="drawerSelect == 1"
          @change="tirePressureValueChange()"
        >
        </el-slider>
        <el-slider
          v-model="tireTemperatureValue"
          range
          :marks="marks"
          style="width: 50%; margin-left: 20px"
          v-if="drawerSelect == 2"
          @change="tireTemperatureValueChange()"
        >
        </el-slider>

        <!-- <el-button type="info" size="mini" @click="clearInput()" class="btnInsert" icon="el-icon-refresh">娓呯┖
				</el-button>-->
        <el-button
          type="success"
          size="mini"
          @click="openInsertSensorData()"
          class="btnInsert"
          icon="el-icon-search"
          >{{ $t("sensorsmanage.sensordata.historydata.insert.btn") }}
        </el-button>
<!--        显示折线图-->
        <el-button v-if="this.exits" @click="searchData1()"
          >{{ $t("sensorsmanage.sensordata.historydata.inner_btn") }}
        </el-button>
<!--        下载传感器数据 状态显示-->
        <el-button v-if="exits" @click="downloadData()">
          {{ $t("sensorsmanage.sensordata.historydata.download_btn") }}
          <span v-if="downloadStatus === 'downloading'" style="margin-left: 8px;">
          （{{ $t("sensorsmanage.sensordata.historydata.downloading") }}...）
          </span>
          <span v-else-if="downloadStatus === 'packaging'" style="margin-left: 8px;">
            （{{ $t("sensorsmanage.sensordata.historydata.packaging") }}... {{ packagingProgress }}%）
          </span>
        </el-button>

        <el-drawer
          v-if="this.exits"
          :title="drawerTitle1"
          :append-to-body="true"
          :close-on-press-escape="true"
          :visible.sync="innerdrawer"
          :direction="direction1"
          size="80%"
        >
          <el-form
            v-loading="loading1"
            element-loading-text="Loading"
            class="loadingContainer"
            :style="{ width: '100%', height: '100%', backgroundColor: '#ffffff' }"
          >
            <div class="chartLine_wrap_sensor_data1">
              <div
                id="myChart_sensor_data"
                class="chartLine_wrap_sensor_data1"
                :style="{ width: '100%', height: '100%', backgroundColor: '#ffffff' }"
                :show-close="false"
              ></div>
            </div>
          </el-form>
        </el-drawer>
      </div>

      <el-table
        :data="sensorDatas"
        :visible.sync="drawer"
        style="width: 100%; margin-left: 20%; margin-top: 20px"
        border
      >
        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.tirep')"
          prop=""
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.tirePressure }}
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.temperature')"
          prop=""
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.tireTemperature }}
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.stirep')"
          prop=""
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.tireStandardPressure }}
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.stemperature')"
          prop=""
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.tireStandardTemperature }}
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.date')"
          prop="sensorTime"
          width="200"
        >
        </el-table-column>

        <el-table-column
          :label="this.$t('sensorsmanage.sensordata.historydata.operate')"
          prop=""
          width="200"
        >
          <template slot-scope="scope">
            <el-tag type="warning" class="btn" @click="openUpdateSensorData(scope.row)">{{
              $t("sensorsmanage.sensordata.historydata.modify.btn")
            }}</el-tag>
            <el-tag
              type="danger"
              class="btn"
              @click="deleteOneSensorData(scope.row.id)"
              >{{ $t("sensorsmanage.sensordata.historydata.delete") }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="sensorDataPage"
        :visible.sync="drawer"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="sensorDataLength"
        layout="total, sizes, prev, pager, next, jumper"
        :total="sensorDataTotal"
        class="paginationIn"
      >
      </el-pagination>
    </el-drawer>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="length"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    >
    </el-pagination>

    <!-- 新增、修改传感器基本信息框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
    >
      <el-form :model="sensorBaseInfoForm">
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.mac')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.macId"
            autocomplete="off"
            @input="change($event)"
            :disabled="
              dialogTitle == this.$t('sensorsmanage.sensorbaseinfo.modify.title')
            "
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.sensorid')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.sensorId"
            autocomplete="off"
            @input="change($event)"
            :disabled="
              dialogTitle == this.$t('sensorsmanage.sensorbaseinfo.modify.title')
            "
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.phone')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.phone"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.bleconnectionSensor')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.bleconnectionSensor"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.companyID')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.companyID"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.ignstatus')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.ignstatus"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="
            this.$t('sensorsmanage.sensorbaseinfo.insert.mileageOFTirePressureSensor')
          "
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.mileageOFTirePressureSensor"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.presentDateAndTime')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.presentDateAndTime"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.projectCode')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.projectCode"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.softwareVersion')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.softwareVersion"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensorbaseinfo.insert.vehicleOdometer')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorBaseInfoForm.vehicleOdometer"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancle()">{{
          $t("sensorsmanage.sensorbaseinfo.insert.cancel")
        }}</el-button>
        <el-button type="primary" @click="toSensorBaseInfo()">{{ btnName }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增、修改传感器历史数据框 -->
    <el-dialog
      :title="drawerDialogTitle"
      :visible.sync="drawerDialogFormVisible"
      :width="drawerDialogWidth"
      :close-on-click-modal="false"
    >
      <el-form :model="sensorDataForm">
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.mac')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.sensorId"
            autocomplete="off"
            @input="change($event)"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.sensorid')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.macId"
            autocomplete="off"
            @input="change($event)"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.tirep')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.tirePressure"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.temperature')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.tireTemperature"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.stirep')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.tireStandardPressure"
            autocomplete="off"
            @input="change($event)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('sensorsmanage.sensordata.historydata.modify.stemperature')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="sensorDataForm.tireStandardTemperature"
            autocomplete="off"
            @input="change($event)"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="drawerCancle()">{{
          $t("sensorsmanage.sensordata.historydata.modify.cancel")
        }}</el-button>
        <el-button type="primary" @click="toSensorData()">{{ btnName }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest1} from "../../../utils/api";

export default {
  data() {
    return {
      exits: false,
      sensorDatas: [
        {
          id: "",
          macId: "",
          sensorId: "",
          tirePressure: "",
          tireTemperature: "",
          tireStandardPressure: "",
          tireStandardTemperature: "",
          sensorTime: "",
          sensorVersion: "",
        },
        {
          id: "",
          macId: "",
          sensorId: "",
          tirePressure: "",
          tireTemperature: "",
          tireStandardPressure: "",
          tireStandardTemperature: "",
          sensorTime: "",
          sensorVersion: "",
        },
      ],
      drawersensorDatas: [
        {
          id: "",
          macId: "",
          sensorId: "",
          tirePressure: "",
          tireTemperature: "",
          tireStandardPressure: "",
          tireStandardTemperature: "",
          sensorTime: "",
          sensorVersion: "",
        },
      ],
      downloadSensorDatas: [
        {
          list: ""
        },
      ],
      downloadStatus: '', // 状态：'downloading', 'packaging'
      packagingProgress: 0,
      sensorBaseInfos: [
        {
          macId: "",
          sensorId: "",
          phone: "",
          bleconnectionSensor: "",
          companyID: "",
          ignstatus: "",
          mileageOFTirePressureSensor: "",
          presentDateAndTime: "",
          projectCode: "",
          softwareVersion: "",
          vehicleOdometer: "",
          // addData: "",
        },
      ],
      sensorBaseInfoForm: {
        macId: "",
        sensorId: "",
        phone: "",
        bleconnectionSensor: "",
        companyID: "",
        ignstatus: "",
        mileageOFTirePressureSensor: "",
        presentDateAndTime: "",
        projectCode: "",
        softwareVersion: "",
        vehicleOdometer: "",
        // addData: "",
      },
      search: "",
      MacSearch: "",
      tirePressureSearch: "",
      tireStandardPressureSearch: "",
      page: 1,
      total: 0,
      length: 5,
      dialogWidth: "30%",
      dialogTitle: "新增传感器基本信息",
      dialogFormVisible: false,
      drawerDialogWidth: "30%",
      drawerDialogTitle: "新增传感器数据",
      drawerDialogFormVisible: false,
      btnName: "新增",
      formLabelWidth: "160px",
      macId: "",
      sensorId: "",
      isLock: false,
      index: 0,
      input3: "",
      select: "",
      drawerSelect: "",
      drawerSearch: "",
      drawer: false,
      innerdrawer: false,
      direction: "btt",
      direction1: "btt",
      drawerTitle: "",
      drawerTitle1: "",
      sensorDataPage: 1,
      sensorDataLength: 5,
      sensorDataTotal: 0,
      sensorDataForm: {
        id: "",
        macId: "",
        sensorId: "",
        tirePressure: "",
        tireTemperature: "",
        tireStandardPressure: "",
        tireStandardTemperature: "",
        sensorTime: "",
      },
      currentMacId: "",
      tirePressureValue: [20, 80],
      tireTemperatureValue: [1, 100],
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA",
          },
          label: this.$createElement("strong", "50°C"),
        },
        100: {
          style: {
            color: "red",
          },
          label: this.$createElement("strong", "100°C"),
        },
      },
      sp: [],
      st: [],
      p: [],
      t: [],
      time1: [],
      loading1: false,
      str_finall: "",
    };
  },
  created() {
    this.reload();
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    selectChange() {},
    drawerSelectChange() {
      // alert(this.drawerSelect);
    },
    drawerOpen(macId) {
      console.log(`drawerOpen mac id: ${this.macId}`);
      this.drawer = true;
      this.drawerTitle =
        this.$t("sensorsmanage.sensordata.historydata.historydatatitle1") +
        macId +
        this.$t("sensorsmanage.sensordata.historydata.historydatatitle2");
      this.currentMacId = macId;
      console.log(`drawerOpen currentMacId mac id: ${macId}`);
      this.drawerSelect = "";
      this.drawerSearch = "";
      this.getRequest(
        "/tpa-api/manageSensor/getSensorById/" +
          macId +
          "?length=" +
          this.sensorDataLength +
          "&page=" +
          this.sensorDataPage,
        null
      ).then((resp) => {
        if (resp) {
          this.sensorDatas = resp.result;
          this.sensorDataTotal = resp.total;
        }
        if (this.sensorDataTotal !== undefined) {
          this.exits = true;
        } else {
          this.exits = false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    openUpdateSensorData(row) {
      this.drawerDialogFormVisible = true;
      this.drawerDialogTitle = this.$t(
        "sensorsmanage.sensordata.historydata.modify.title"
      );
      this.btnName = this.$t("sensorsmanage.sensordata.historydata.modify.btn");
      this.sensorDataForm.id = row.id;
      this.sensorDataForm.macId = this.currentMacId;
      this.sensorDataForm.tirePressure = row.tirePressure;
      this.sensorDataForm.tireTemperature = row.tireTemperature;
      this.sensorDataForm.tireStandardPressure = row.tireStandardPressure;
      this.sensorDataForm.tireStandardTemperature = row.tireStandardTemperature;
    },
    openInsertSensorData() {
      this.drawerDialogFormVisible = true;
      this.drawerDialogTitle = this.$t(
        "sensorsmanage.sensordata.historydata.insert.title"
      );
      this.btnName = this.$t("sensorsmanage.sensordata.historydata.insert.btn");
      this.sensorDataForm.macId = this.currentMacId;
    },
    reload() {
      let that = this;
      let length = that.length;
      let page = that.page;
      let select = that.select;
      let search = that.search;

      console.log("reload  select " + select + " search " + search);

      // if ((search = "")) {
      //   index = 0;
      // }

      if (select === "1") {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo/?keyword=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=1",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
      else if (select === "2") {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo/?keyword=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=2",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
      else {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo?length=" +
              length +
              "&page=" +
              page +
              "&option=0",
            null
          )
          .then((resp) => {
            if (resp) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
    },
    reload2() {
      let that = this;
      let length = that.sensorDataLength;
      let page = that.sensorDataPage;
      let macId = that.currentMacId;
      let index = that.drawerSelect;
      let search = that.drawerSearch;
      let tirePressureValue = that.tirePressureValue;
      let tireTemperatureValue = that.tireTemperatureValue;

      // 胎压搜索
      if (index === 1) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?value=" +
              tirePressureValue +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=1",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      } else if (index === 2) {
        // 温度搜索
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?value=" +
              tireTemperatureValue +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=2",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      } else if (index === 3) {
        // 标压搜索
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?key=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=3",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      } else if (index === 4) {
        // 标温搜索
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?key=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=4",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.total = resp.total;
            }
          });
      } else {
        // 查询全部
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?length=" +
              length +
              "&page=" +
              page +
              "&option=0",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      }
    },
    // 分页功能
    handleSizeChange(val) {
      this.length = val;
      this.reload();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.reload();
    },
    handleSizeChange2(val) {
      this.sensorDataLength = val;
      this.reload2();
    },
    handleCurrentChange2(val) {
      this.sensorDataPage = val;
      this.reload2();
    },
    cancle() {
      this.dialogFormVisible = false;
      this.reload();
    },
    drawerCancle() {
      this.drawerDialogFormVisible = false;
      this.reload2();
    },
    clearInput() {
      this.MacSearch = "";
      this.tirePressureSearch = "";
      this.tireStandardPressureSearch = "";
      this.reload();
    },
    sensorSearchBaseInfo() {
      let that = this;
      let length = that.length;
      let select = that.select;
      that.page = 1;
      let page = that.page;
      let search = that.search;

      if (select == 0) {
        this.$message("请选择要查询的类型");
        return;
      }
      else if (select == 1) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo/?keyword=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=1",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
      else if (select == 2) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo/?keyword=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=2",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
      else if (select == 3) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorBaseInfo/?keyword=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=3",
              null
            )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorBaseInfos = resp.result;
              that.total = resp.total;
            }
          });
      }
    },
    // 获取传感器的基本信息
    tableClick: function (macId) {
      let that = this;
      that.sensorBaseInfo = [];

      that
        .getRequest("/tpa-api/manageSensor/getSensorBaseInfo/" + macId, null)
        .then((resp) => {
          if (resp) {
            that.sensorBaseInfo = resp.result;
          }
        });
    },
    openInsertSensorBaseInfo() {
      this.dialogFormVisible = true;
      this.dialogTitle = this.$t("sensorsmanage.sensorbaseinfo.insert.btn");
      this.btnName = this.$t("sensorsmanage.sensorbaseinfo.insert.insert");
    },
    openUpdateSensorBaseInfo(row) {
      this.dialogFormVisible = true;
      this.dialogTitle = this.$t("sensorsmanage.sensorbaseinfo.modify.title");
      this.btnName = this.$t("sensorsmanage.sensorbaseinfo.modify.btn");
      this.sensorBaseInfoForm.macId = row.macId;
      this.sensorBaseInfoForm.phone = row.phone;
      this.sensorBaseInfoForm.bleconnectionSensor = row.bleconnectionSensor;
      this.sensorBaseInfoForm.companyID = row.companyID;
      this.sensorBaseInfoForm.ignstatus = row.ignstatus;
      this.sensorBaseInfoForm.mileageOFTirePressureSensor =
        row.mileageOFTirePressureSensor;
      this.sensorBaseInfoForm.presentDateAndTime = row.presentDateAndTime;
      this.sensorBaseInfoForm.projectCode = row.projectCode;
      this.sensorBaseInfoForm.softwareVersion = row.softwareVersion;
      this.sensorBaseInfoForm.vehicleOdometer = row.vehicleOdometer;
      //      this.sensorBaseInfoForm.addData = row.addData;
    },
    toSensorBaseInfo() {
      let that = this;
      let btnName = that.btnName;
      if (btnName == this.$t("sensorsmanage.sensorbaseinfo.insert.insert")) {
        let insertData = {
          macId: that.sensorBaseInfoForm.macId,
          phone: that.sensorBaseInfoForm.phone,
          bleconnectionSensor: that.sensorBaseInfoForm.bleconnectionSensor,
          companyID: that.sensorBaseInfoForm.companyID,
          ignstatus: that.sensorBaseInfoForm.ignstatus,
          mileageOFTirePressureSensor:
            that.sensorBaseInfoForm.mileageOFTirePressureSensor,
          presentDateAndTime: that.sensorBaseInfoForm.presentDateAndTime,
          projectCode: that.sensorBaseInfoForm.projectCode,
          softwareVersion: that.sensorBaseInfoForm.softwareVersion,
          vehicleOdometer: that.sensorBaseInfoForm.vehicleOdometer,
          // adddata: that.sensorBaseInfoForm.addData,
        };
        that
          .postRequest("/tpa-api/manageSensor/insertSensorBaseInfo", insertData)
          .then((resp) => {
            if (resp.code == 200) {
              // 关闭对话框，刷新页面
              that.dialogFormVisible = false;
              that.reload();
            }
          });
        that.sensorBaseInfoForm = {
          macId: "",
          sensorId: "",
          phone: "",
          bleconnectionSensor: "",
          companyID: "",
          ignstatus: "",
          mileageOFTirePressureSensor: "",
          presentDateAndTime: "",
          projectCode: "",
          softwareVersion: "",
          vehicleOdometer: "",
          // addData: "",
        };
      } else if (btnName == this.$t("sensorsmanage.sensorbaseinfo.modify.btn")) {
        let updateData = {
          macId: that.sensorBaseInfoForm.macId,
          phone: that.sensorBaseInfoForm.phone,
          bleconnectionSensor: that.sensorBaseInfoForm.bleconnectionSensor,
          companyID: that.sensorBaseInfoForm.companyID,
          ignstatus: that.sensorBaseInfoForm.ignstatus,
          mileageOFTirePressureSensor:
            that.sensorBaseInfoForm.mileageOFTirePressureSensor,
          presentDateAndTime: that.sensorBaseInfoForm.presentDateAndTime,
          projectCode: that.sensorBaseInfoForm.projectCode,
          softwareVersion: that.sensorBaseInfoForm.softwareVersion,
          vehicleOdometer: that.sensorBaseInfoForm.vehicleOdometer,
          // adddata: that.sensorBaseInfoForm.addData,
        };
        that
          .postRequest("/tpa-api/manageSensor/updateSensorBaseInfo", updateData)
          .then((resp) => {
            if (resp.code == 200) {
              // 关闭对话框，刷新页面
              that.dialogFormVisible = false;
              that.reload();
              that.sensorBaseInfoForm = {
                macId: "",
                sensorId: "",
                phone: "",
                bleconnectionSensor: "",
                companyID: "",
                ignstatus: "",
                mileageOFTirePressureSensor: "",
                presentDateAndTime: "",
                projectCode: "",
                softwareVersion: "",
                vehicleOdometer: "",
                // addData: "",
              };
            }
          });
      }
    },
    deleteOneSensorBaseInfo(id) {
      // 跳出确认框
      let that = this;
      that
        .$confirm(
          this.$t("notification.sensorbaseinfomessage"),
          this.$t("notification.title"),
          {
            confirmButtonText: this.$t("notification.confirm"),
            cancelButtonText: this.$t("notification.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          // 发送ajax请求删除数据
          that
            .deleteRequest("/tpa-api/manageSensor/deleteSensorBaseInfo/" + id, null)
            .then((resp) => {
              if (resp.code == 200) {
                that.page = 1;
                that.length = 5;
                // 重新加载
                that.reload();
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: this.$t("notification.cancelinfo"),
          });
        });
    },
    sensorDataSearch() {
      let that = this;
      let length = that.sensorDataLength;
      let select = that.drawerSelect;
      that.sensorDataPage = 1;
      let page = that.sensorDataPage;
      let search = that.drawerSearch;
      let macId = that.currentMacId;
      if (select == 0) {
        this.$message("请选择要查询的类型");
        return;
      }
      if (search == "" || select == 0) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?length=" +
              length +
              "&page=" +
              page +
              "&option=0",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
        return;
      }
      if (select == 3) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?key=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=3",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      }

      if (select == 4) {
        that
          .getRequest(
            "/tpa-api/manageSensor/getSensorByIdAndKey/" +
              macId +
              "?key=" +
              search +
              "&length=" +
              length +
              "&page=" +
              page +
              "&option=4",
            null
          )
          .then((resp) => {
            if (resp.code == 200) {
              that.sensorDatas = resp.result;
              that.sensorDataTotal = resp.total;
            }
          });
      }
    },
    tirePressureValueChange() {
      let that = this;
      let length = that.sensorDataLength;
      let page = 1;
      that.sensorDataPage = page;
      let index = that.index;
      let tirePressureValue = that.tirePressureValue;
      let macId = that.currentMacId;
      that
        .getRequest(
          "/tpa-api/manageSensor/getSensorByIdAndKey/" +
            macId +
            "?value=" +
            tirePressureValue +
            "&length=" +
            length +
            "&page=" +
            page +
            "&option=1",
          null
        )
        .then((resp) => {
          if (resp.code == 200) {
            that.sensorDatas = resp.result;
            that.sensorDataTotal = resp.total;
          }
        });
    },
    tireTemperatureValueChange() {
      let that = this;
      let length = that.sensorDataLength;
      let page = 1;
      that.sensorDataPage = page;
      let index = that.index;
      let tireTemperatureValue = that.tireTemperatureValue;
      let macId = that.currentMacId;
      that
        .getRequest(
          "/tpa-api/manageSensor/getSensorByIdAndKey/" +
            macId +
            "?value=" +
            tireTemperatureValue +
            "&length=" +
            length +
            "&page=" +
            page +
            "&option=2",
          null
        )
        .then((resp) => {
          if (resp.code == 200) {
            that.sensorDatas = resp.result;
            that.sensorDataTotal = resp.total;
          }
        });
    },
    toSensorData() {
      let that = this;
      let btnName = that.btnName;
      let currentMacId = that.currentMacId;
      if (btnName == "新增") {
        let insertData = {
          macId: currentMacId,
          tirePressure: that.sensorDataForm.tirePressure,
          tireTemperature: that.sensorDataForm.tireTemperature,
          tireStandardPressure: that.sensorDataForm.tireStandardPressure,
          tireStandardTemperature: that.sensorDataForm.tireStandardTemperature,
        };
        that
          .postRequest("/tpa-api/manageSensor/insertSensorData", insertData)
          .then((resp) => {
            if (resp.code == 200) {
              // 关闭对话框，刷新页面
              that.drawerDialogFormVisible = false;
              that.reload2();
            }
          });
        that.sensorDataForm = {
          id: "",
          macId: "",
          sensorId: "",
          tirePressure: "",
          tireTemperature: "",
          tireStandardPressure: "",
          tireStandardTemperature: "",
          sensorTime: "",
        };
      } else if (btnName == "修改") {
        let updateData = {
          id: that.sensorDataForm.id,
          macId: currentMacId,
          tirePressure: that.sensorDataForm.tirePressure,
          tireTemperature: that.sensorDataForm.tireTemperature,
          tireStandardPressure: that.sensorDataForm.tireStandardPressure,
          tireStandardTemperature: that.sensorDataForm.tireStandardTemperature,
        };
        that
          .postRequest("/tpa-api/manageSensor/updateSensorData", updateData)
          .then((resp) => {
            if (resp.code == 200) {
              // 关闭对话框，刷新页面
              that.drawerDialogFormVisible = false;
              that.reload2();
              that.sensorDataForm = {
                id: "",
                macId: "",
                sensorId: "",
                tirePressure: "",
                tireTemperature: "",
                tireStandardPressure: "",
                tireStandardTemperature: "",
                sensorTime: "",
              };
            }
          });
      }
    },
    deleteOneSensorData(id) {
      // 跳出确认框
      let that = this;
      that
        .$confirm(
          this.$t("notification.sensordatamessage"),
          this.$t("notification.title"),
          {
            confirmButtonText: this.$t("notification.confirm"),
            cancelButtonText: this.$t("notification.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          // 发送ajax请求删除数据
          that
            .deleteRequest("/tpa-api/manageSensor/deleteSensorData/" + id, null)
            .then((resp) => {
              if (resp.code == 200) {
                that.sensorDataPage = 1;
                // 重新加载
                that.drawerSelect = "";
                that.drawerSearch = "";
                that.reload2();
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: this.$t("notification.cancelinfo"),
          });
        });
    },
    searchData1() {
      this.getRequest(
        "/tpa-api/manageSensor/getSensorById1/" + this.currentMacId,
        null
      ).then((resp) => {
        if (resp) {
          this.drawersensorDatas = resp.result;
        }
        if (this.drawersensorDatas !== undefined) {
          this.exits = true;
        } else {
          this.exits = false;
        }
      });
      this.innerdrawer = true;
      this.loading1 = true;
      setTimeout(() => {
        var data = this.drawersensorDatas;
        this.t = data.map((i) => {
          return i.tireTemperature;
        });
        this.t.reverse();
        this.p = data.map((i) => {
          return i.tirePressure;
        });
        this.p.reverse();
        this.st = data.map((i) => {
          return i.tireStandardTemperature;
        });
        this.st.reverse();
        this.sp = data.map((i) => {
          return i.tireStandardPressure;
        });
        this.sp.reverse();
        this.time1 = data.map((i) => {
          return i.sensorTime;
        });
        this.time1.reverse();
        this.loading1 = false;
        this.drawLine1(); //折线图
      }, 1500);
    },
    async downloadData() {
      this.downloadStatus = 'downloading';
      try {
        const token = window.localStorage.getItem("token");
        const headers = new Headers();
        headers.append('token', token);
        const requestOptions = {
          method: 'GET',
          headers: headers,
          // 其他选项（如credentials等）可以在这里添加
        };
        const urlstring = "/tpa-api/manageSensor/getSensorById2";
        const params = { macId: this.currentMacId };
        const url1 = `${urlstring}${encodeURIComponent(this.currentMacId)}`;
        console.log(this.currentMacId + " downloadData  " + urlstring);
        const response = await getRequest1("/tpa-api/manageSensor/getSensorById2/" + this.currentMacId, params);

        // 处理非 200 状态码
        if (!response.ok) {
          response.json().then(errorData => {
            // 创建自定义错误对象，包含响应状态和错误数据
            const error = new Error(`Request failed with status ${response.status}`);
            error.status = response.status;
            error.data = errorData;
            throw error;
          })
        }

        // 检查响应内容类型
        const contentType = response.headers.get('content-type');
        console.log("contentType  " + contentType.toString());
        // 处理不同响应类型
        if (contentType && contentType.includes('csv')) {
          // 从 Content-Disposition 获取文件名
          const contentDisposition = response.headers.get('content-disposition');
          console.log("contentDisposition  " + contentDisposition);
          const cleanMacId = this.currentMacId.replace(":", "_");
          const filename = "sensor_data_" + cleanMacId + ".csv";

          // 创建文件下载
          const blob = await response.blob();
          this.saveFile(blob, filename);
          this.downloadStatus = 'success';
        } else {
          throw new Error(`不支持的响应类型: ${contentType}`);
        }

      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error(this.$t('notification.downloadfail'));
        this.downloadStatus = '';
      }
    },
    saveFile(blob, filename) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = filename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      // 延迟清理以避免下载中断
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    },
    methods: {
      // 辅助方法：延迟函数用于UI更新
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
    },
    drawLine1() {
      this.drawerTitle1 =
        this.$t("sensorsmanage.sensordata.historydata.historydatatitle1") +
        this.currentMacId +
        this.$t("sensorsmanage.sensordata.historydata.historydatatitle2");

      // 基于准备好的dom，初始化echarts实例
      var dom = document.getElementById("myChart_sensor_data");
      let myChart_sensor_data = this.$echarts.init(dom);
      // 绘制图表
      myChart_sensor_data.setOption({
        tooltip: {
          //触发类型：坐标轴触发
          trigger: "axis", //触发类型  'item'图形触发：散点图，饼图等无类目轴的图表中使用； 'axis'坐标轴触发；'none'：什么都不触发。
          axisPointer: {
            type: "line", //默认为line，line直线，cross十字准星，shadow阴影
            lineStyle: {
              type: "dashed",
              color: "#808BA9",
            },
          },
          backgroundColor: "#fff", //也可以通过设置rgba调节背景颜色与透明度
          color: "#333",
          borderWidth: "1",
          borderColor: "#D9E1F8",
          textStyle: {
            color: "#333",
            fontSize: "12",
            lineHeight: "17",
          },
          extraCssText: "pointer-events: none;",
          formatter: function (arg) {
            let name0, str0, str1, str2, str3, str_finall;
            if (arg[0] !== null && arg[0] !== undefined) {
              name0 = arg[0].name;
              str0 =
                "<br>" +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[0].color +
                ';"></span>' +
                arg[0].seriesName +
                '<span style="margin-left:10px;">' +
                arg[0].data +
                "</span>";
            }
            if (arg[1] !== null && arg[1] !== undefined) {
              str1 =
                "<br>" +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[1].color +
                ';"></span>' +
                arg[1].seriesName +
                '<span style="margin-left:10px;">' +
                arg[1].data +
                "</span>";
            }
            if (arg[2] !== null && arg[2] !== undefined) {
              str2 =
                "<br>" +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[2].color +
                ';"></span>' +
                arg[2].seriesName +
                '<span style="margin-left:10px;">' +
                arg[2].data +
                "</span>";
            }
            if (arg[3] !== null && arg[3] !== undefined) {
              str3 =
                "<br>" +
                '<span style="margin:0 5px 2px 0;display:inline-block;width:6px;height:6px;border-radius:5px;background-color:' +
                arg[3].color +
                ';"></span>' +
                arg[3].seriesName +
                '<span style="margin-left:10px;">' +
                arg[3].data +
                "</span>";
            }
            if (name0 !== null && name0 !== undefined) {
              str_finall = name0;
            }
            if (str0 !== null && str0 !== undefined) {
              str_finall += str0;
            }
            if (str1 !== null && str1 !== undefined) {
              str_finall += str1;
            }
            if (str2 !== null && str2 !== undefined) {
              str_finall += str2;
            }
            if (str3 !== null && str3 !== undefined) {
              str_finall += str3;
            }
            //自定义提示
            return str_finall;
          },
        },
        legend: {
          icon: "circle",
          itemHeight: 10, //修改icon图形大小
          textStyle: {
            fontSize: 14,
            color: "#333",
          },
          x: "left", //可设定图例在左、右、居中
          y: "top", //可设定图例在上、下、居中
          padding: [10, 0, 0, 20], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
        },
        grid: {
          top: "45",
          left: "40",
          right: "55",
          bottom: "80",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          data: this.time1,
          symbol: "arrow",
          //使坐标轴刻度与标签对齐
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            // 改变x轴颜色
            lineStyle: {
              // color: "#D9E1F8",
              color: "#666",
              width: "1",
            },
          },
          axisLabel: {
            // 改变x轴字体颜色和大小
            formatter(val) {
              return "{a|" + `${val}` + "}";
            },
            rich: {
              a: {
                height: 40, // 设置字体行高
                color: "#666",
                fontSize: 14,
              },
            },
          },
        },
        yAxis: {
          type: "value",
          symbol: "arrow",
          axisLine: {
            show: true, //y轴线消失
          },
          axisTick: {
            show: false, //y轴坐标点消失
          },
          boundaryGap: [0, 0], //有负数设置这个
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#D9E1F8",
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: 14,
              color: "#92A5E3",
            },
          },
        },
        series: [
          {
            name: this.$t("sensorsmanage.sensordata.historydata.inner.basiclineT.series"),
            type: "line", //bar:柱状 line:折线图
            data: this.t,
            smooth: true,
            color: "#66FF00",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
          },
          {
            name: this.$t(
              "sensorsmanage.sensordata.historydata.inner.basiclineST.series"
            ),
            type: "line", //bar:柱状 line:折线图
            data: this.st,
            smooth: true,
            color: "#339900",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
          },
          {
            name: this.$t("sensorsmanage.sensordata.historydata.inner.basiclineP.series"),
            type: "line", //bar:柱状 line:折线图
            data: this.p,
            smooth: true,
            color: "#0066FF",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
          },
          {
            name: this.$t(
              "sensorsmanage.sensordata.historydata.inner.basiclineSP.series"
            ),
            type: "line", //bar:柱状 line:折线图
            data: this.sp,
            smooth: true,
            color: "#003399",
            // symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
          },
        ],
        //日期选择器
        toolbox: {
          feature: {
            restore: {
              title: "日期还原",
            },
          },
          left: "370",
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 100,
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
.avatar {
  height: 50px;
}

.chartLine_wrap_sensor_data1 {
  width: 100%;
  height: 100%;
  background: #fff;
}

.btnInsert {
  margin-left: 50px;
  height: 36px;
  font-size: 10px;
  line-height: 10px;
  float: right;
}

.paginationIn {
  display: flex;
  float: left;
  margin-left: 20%;
  margin-top: 40px;
}

.pagination {
  display: flex;
  float: left;
  margin-top: 40px;
}

.search {
  width: 15%;
  height: 50px;
  margin-right: 5px;
}

.searchLable {
  height: 50px;
  line-height: 36px;
  color: #606266;
  margin-left: 5px;
}

.el-select .el-input {
  width: 200px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.header {
  display: flex;
  flex-direction: row;
}

.header_drawer {
  display: flex;
  flex-direction: row;
  margin-left: 20%;
}

.btn {
  cursor: pointer;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.loadingContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
